/* seamless-ticker: duration = width of one copy / speed, so every strip scrolls at the same px/s on any screen.
   Runs once per page even when several strips include it. */
(function () {
  if (window.__stk) return;
  window.__stk = true;
  function size() {
    document.querySelectorAll('[data-stk]').forEach(function (el) {
      var run = el.querySelector('.stk__run');
      var speed = parseFloat(el.dataset.speed) || 45;
      if (!run || !run.offsetWidth) return;
      el.querySelector('.stk__track').style.setProperty('--stk-dur', (run.offsetWidth / speed).toFixed(2) + 's');
    });
  }
  size();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(size);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(size, 150); });
})();
